/**
 * Built-in effect `vignette` (W2-01b; P§5.2): darkens the edges toward `color` (vec4 0..1; in extra.json the vars
 * are [r, g, b, a] integers 0..255). Reimplemented from the behaviour (badged approximate).
 *
 * The clear amount is v = clamp((uv.x (1 - uv.x) uv.y (1 - uv.y) * radius) ^ extend, 0, 1): 0 on the screen's edges,
 * near 1 in the middle. A larger `radius` widens the clear middle, a larger `extend` spreads the vignette inward.
 * The pixel is mixed toward color.rgb by (1 - v) * color.a; its alpha is kept.
 */

import { m } from './builtinFx.messages';
import { defineBuiltin } from './shared';

export const vignette = defineBuiltin({
  name: 'vignette',
  label: { key: m.vignette },
  description: { key: m.vignetteDesc },
  inputs: [],
  uniforms: [
    { name: 'color', type: 'vec4', default: [0, 0, 0, 1], label: { key: m.vignetteColor } },
    { name: 'extend', type: 'float', default: 0.25, hint: '0..1', min: 0, max: 1, label: { key: m.vignetteExtend } },
    { name: 'radius', type: 'float', default: 15, min: 0, max: 100, label: { key: m.vignetteRadius } },
  ],
  main: `
void main() {
  vec4 c = texture2D(screenTexture, uv);
  vec2 e = uv * (1.0 - uv);
  float v = clamp(pow(max(e.x * e.y * radius, 1e-6), extend), 0.0, 1.0);
  float k = (1.0 - v) * color.a;
  gl_FragColor = vec4(mix(c.rgb, color.rgb, k), c.a);
}`,
});
